// extracted by mini-css-extract-plugin
export default {"root":"_1LgrRQyg","content":"_1So3iwxb"};